import { render, staticRenderFns } from "./EmployeeArticles.vue?vue&type=template&id=56c57b05&scoped=true&"
import script from "./EmployeeArticles.vue?vue&type=script&lang=js&"
export * from "./EmployeeArticles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c57b05",
  null
  
)

export default component.exports